import React from 'react';
import {
    Box,
    FormControl,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
    useTheme,
} from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { capitalizeFirstLetter } from '@europrocurement/l2d-utils';

export type DocumentType = {
    id: number;
    label: string;
};

export type DossierDocumentTypeSelectProps = {
    types: Array<DocumentType>;
    currentType: number;
    onChange: (type: DocumentType) => void;
};

const DossierDocumentTypeSelect: React.FunctionComponent<DossierDocumentTypeSelectProps> =
    function (props) {
        const { types, currentType, onChange } = props;
        const { palette } = useTheme();
        const handleChange = (typeId: number) => {
            const newType = types.find((t) => t.id === typeId);

            if (newType) {
                onChange(newType);
            }
        };

        const menuLabelSx = {
            height: '23px',
            display: 'flex',
            alignItems: 'center',
            gap: '0 6px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        };

        const iconSx = {
            display: 'flex',
            alignItems: 'center',
            lineHeight: 0,
            color: palette.grey[500],
            fontSize: '16px',
        };

        return (
            <FormControl
                size="small"
                onClick={(e) => {
                    e.stopPropagation();
                }}
                sx={{ borderColor: '#ff0000' }}
            >
                <Select
                    sx={{
                        width: '150px',
                        backgroundColor: palette.grey[100],
                        display: 'flex',
                        alignItems: 'center',
                        borderColor: '#ff0000',
                    }}
                    value={currentType as unknown as string}
                    onChange={(event: SelectChangeEvent) => {
                        handleChange(event.target.value as unknown as number);
                    }}
                    inputProps={{ sx: { borderColor: '#ff0000' } }}
                >
                    {types.map((type) => (
                        <MenuItem
                            key={`${type.label}-${type.id}`}
                            value={type.id}
                        >
                            <Box sx={menuLabelSx}>
                                <FaOptionIcon
                                    sx={iconSx}
                                    icon={['fasl', 'tag']}
                                />
                                <Typography
                                    component="span"
                                    variant="caption"
                                    sx={menuLabelSx}
                                >
                                    {capitalizeFirstLetter(type.label)}
                                </Typography>
                            </Box>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    };

export default DossierDocumentTypeSelect;
